import { env } from '@shared/config';
import { AppLocale, defaultLocale } from '../config';

export { validationI18n } from './validations-i18n';

export const isSupportedLocale = (locale: string): locale is AppLocale => {
  /**
   * To resolve `Argument of type 'string' is not assignable to parameter of type 'AppLocale'`
   *
   * @see https://github.com/microsoft/TypeScript/issues/26255#issuecomment-488782539
   */
  const supportedLocalesToString: string[] = Object.values(AppLocale);
  return supportedLocalesToString.includes(locale);
};

/**
 * @description Method to parse string to a supported locale
 */
export const getLocale = (
  unSaveLocale: string,
  fallbackLocale = defaultLocale,
) => {
  if (isSupportedLocale(unSaveLocale)) {
    return unSaveLocale;
  }

  return fallbackLocale;
};

export const getCookieDomain = () => {
  if (env.MODE === 'production') {
    return 'aviata.kz';
  }

  if (env.MODE === 'staging') {
    return '.aviata.team';
  }

  return undefined;
};
